import React, {FC, useState} from 'react'
import {Dropdown, DropdownProps} from "@fluentui/react-northstar"
import {User} from "../../types"
import EmptyFieldError from "./EmptyFieldError"
import {FormLabel} from "./styles"
import {Pair} from "./index";

interface Props {
    users: Partial<User>[]
    onUserChange: (values: Pair[]) => void,
    onSearchQueryChange: (value: string) => void
    error: boolean
    disabled?: boolean,
}

const Users: FC<Props> = ({users, onUserChange, disabled, error, onSearchQueryChange}) => {
    const [currentValues, setCurrentValues] = useState<any>([])
    const [searchString, setSearchString] = useState<string>("")

    const handleValueChange = (_: any, {value}: DropdownProps) => {
        if (value && Array.isArray(value)) {
            setCurrentValues(value)
            const newValues: Pair[] = value.map((v: any) => ({uuid: v.uuid, name: v.header}))
            onUserChange(newValues)
        }
    }

    const handleSearchStringChange = (_: any, {searchQuery}: DropdownProps) => {
        setSearchString(searchQuery || "")
        onSearchQueryChange(searchQuery || "")
    }

    const getCurrentValues = () => {
        return currentValues.map((currentValue: any) => {
            return {
                ...currentValue,
                styles: {
                  fontWeight: "normal",
                  gap: "8px",
                  padding: "0px 10px 0px 24px",
                }
            }
        })
    }

    return (
        <div>
            <FormLabel>
              Send a recognition to
            </FormLabel>
            <Dropdown
                styles={{
                  padding: "0px",
                  margin: "3px 0px"
                }}
                multiple
                search
                fluid
                disabled={disabled}
                value={getCurrentValues()}
                placeholder="Start typing name or email to search"
                noResultsMessage="No match found"
                onChange={handleValueChange}
                searchQuery={searchString}
                onSearchQueryChange={handleSearchStringChange}
                items={users.map(({firstName, lastName, uuid}) => (
                        {header: `${firstName} ${lastName}`, uuid}
                    )
                )}
            />
            {error && <EmptyFieldError/>}
        </div>
    )
}

export default Users
